import * as React from "react";
type Props = {
  className?: string,
};
function SvgMagnifyingGlass({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-magnifying-glass"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3C13.866 3 17 6.13401 17 10C17 11.5723 16.4816 13.0236 15.6064 14.1922L21.0011 19.5869L19.5869 21.0011L14.1912 15.6071C13.0228 16.4819 11.5719 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM10 5C7.23858 5 5 7.23858 5 10C5 12.7614 7.23858 15 10 15C12.7614 15 15 12.7614 15 10C15 7.23858 12.7614 5 10 5Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgMagnifyingGlass;
